module.exports = __webpack_public_path__ + "static/media/altshuler-logo.ef88857a.png";